export default __webpack_public_path__ + "static/media/linkdin.39d9dff7.png";